import { members, notify } from '../wiring'
import { addEmergencyContact, removeEmergencyContact } from '../application/manage-emergency-contacts'
import { archiveMember } from '../application/archive-member'
import { upsertMember } from '../application/upsert-member'
import { setMemberAvatar } from '../application/set-member-avatar'
import type { UpsertInput } from '../application/upsert-member'
import type { EmergencyContact } from '../domain/member'

const useMemberActions = () => {
	const saveMember = (data: UpsertInput & { id?: string }) =>
		upsertMember(members, data, notify)

	const archiveTeamMember = (id: string) =>
		archiveMember(members, id, notify)

	const addContact = (memberId: string, contact: Omit<EmergencyContact, 'id'>) =>
		addEmergencyContact(members, memberId, contact, notify)

	const removeContact = (memberId: string, contactId: string) =>
		removeEmergencyContact(members, memberId, contactId, notify)

	const uploadAvatar = (memberId: string, file: File) =>
		setMemberAvatar(members, memberId, file, notify)

	return { saveMember, archiveTeamMember, addContact, removeContact, uploadAvatar }
}

export { useMemberActions }
